<svelte:options
  customElement={{
    tag: "oc-toggletip-v1",

    extend: window.__components.extend(),
    props: {
      position: { type: "String" },
      visible: { type: "Boolean", reflect: true },
      sticky: { type: "Boolean", reflect: true },
      headline: { type: "String" },
      iconType: { type: "String", attribute: "icon-type" },
      headlineLevel: { type: "Number", attribute: "headline-level" },
      ocAriaLabel: { type: "String", attribute: "oc-aria-label" },
    },
  }}
/>

<script lang="ts">
  import { useSlots } from "../../../common/utils/useSlots.svelte";
  import type { Props } from "./ToggletipV1.types";
  import type { BetaProps } from "./ToggletipV1.types.beta";

  let {
    position,
    visible = false,
    sticky = false,
    headline,
    iconType,
    headlineLevel = undefined,
    ocAriaLabel,
  }: Props & BetaProps = $props();

  const Host = $host();

  const slots = useSlots(Host);
  const headlineElement = $derived(headlineLevel ? `h${headlineLevel}` : "div");

  let contextElement = $state<HTMLElement>();
  let popoverElement = $state<HTMLOcPopoverV1Element>();

  export function recalcPosition(): void {
    popoverElement?.recalcPosition();
  }

  /*                                                             */
  /*                                          */
</script>

<div class="toggletip-box" bind:this={contextElement}>
  <slot />
</div>
<oc-popover-v1
  variant="toggletip"
  {visible}
  {sticky}
  anchor={contextElement}
  {position}
  close-button
  oc-aria-label={ocAriaLabel ?? headline}
  bind:this={popoverElement}
>
  <div class="main">
    {#if iconType}
      <div class="icon-wrapper"><oc-icon-v1 type={iconType} color="#fff"></oc-icon-v1></div>
    {/if}
    {#if headline}
      <svelte:element this={headlineElement} id="toggletip-headline" class="headline">
        {headline}
      </svelte:element>
    {/if}
    <slot name="toggletip-content" id="toggletip-content" />
  </div>
  {#if slots["toggletip-actions"]}
    <div class="actions">
      <slot name="toggletip-actions" />
    </div>
  {/if}
</oc-popover-v1>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  :global {
    :host {
      display: inline-block;
    }

    .toggletip-box {
      display: inline-block;
      max-width: 100%;
      vertical-align: bottom; /*                                                                  */
    }

    .main {
      display: flex;
    }

    .icon-wrapper {
      padding-top: tokens.$oc-component-toggletip-gap-y;
      padding-right: tokens.$oc-component-toggletip-gap-x;
    }

    .inline-wrapper {
      display: inline-block;
      width: max-content;
      max-width: 100%;
      padding: tokens.$oc-component-toggletip-gap-y 0 tokens.$oc-component-toggletip-gap-y;
      hyphens: auto;
      overflow-wrap: break-word;
    }

    .headline {
      font: tokens.$oc-component-toggletip-headline-font;
      margin-top: 0;
      margin-bottom: tokens.$oc-component-toggletip-gap-y;
    }

    .actions {
      text-align: right;
    }

    .close-button-wrapper {
      min-height: calc(1lh + 2 * tokens.$oc-component-toggletip-gap-y);
      display: inline-flex;
      align-items: center;
      float: right;
      margin: calc(-1 * tokens.$oc-component-toggletip-gap-y) 0
        calc(-1 * tokens.$oc-component-toggletip-gap-y) tokens.$oc-component-toggletip-gap-x;
    }
  }
</style>
